/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";

@Injectable({
    providedIn: "root",
})
export class SimAutoUpdateService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * Triggers an automatic update of the SimStation software to the latest version.
 */ 

    public triggerAutoUpdate() {
        return super.get<void>(`/api/AutoUpdate/TriggerAutoUpdate`, );
    }
}